import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-transfer-advertising',
  templateUrl: './transfer-advertising.component.html',
  styleUrls: ['./transfer-advertising.component.scss']
})
export class TransferAdvertisingComponent {

  constructor(
    public dialog: MatDialogRef<TransferAdvertisingComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { action:string },
  ){}

}
